<script lang="ts">
  import { getStoresContext } from "~/stores";
  export let request_store_key;
  const { event } = getStoresContext(request_store_key);
  const images: string[] = $event.images || [];
  const [primary_img, secondary_img] = $event.images || [];
</script>

{#if images.length}
  <!-- if there is secondary image, use the primary image as desktop banner and secondary image as mobile banner. -->
  <!-- if there is no secondary image, use the primary image as mobile banner. -->
  <picture>
    {#if secondary_img} 
      <source media="(min-width: 768px)" srcset={primary_img} /> 
      <source media="(max-width: 767px)" srcset={secondary_img} />
    {/if}
    {#if !secondary_img}
      <source media="(max-width: 767px)" srcset={primary_img} /> 
    {/if}
    <img src="" alt="" />
  </picture>
{/if}

<style lang="scss">
  picture {
    width: 100%;
  }
  img, picture {
    width: 100%;
    object-fit: cover;
  }
</style>